import { __PostsPageURL } from 'aloEjare/posts/posts.url';
import { __PostsFiltersType } from 'aloEjare/posts/posts.type';

type routeParam = string | number;

// absolute paths of project pages
export const __PATH = {
    home: '/',
    posts: (queries?: __PostsFiltersType) => `/posts${queries ? '?' + __PostsPageURL(queries).searchParams : ''}`,
    bulkPosts: (queries?: __PostsFiltersType) =>
        `/bulk-posts${queries ? '?' + __PostsPageURL(queries).searchParams : ''}`,
    postDetail: (slug: routeParam) => `${__PATH.posts()}/${slug}`,
    categories: () => `/categories`,
    login: (redirect?: string) => `/login${redirect ? '?redirect=' + redirect : ''}`,
    aboutUs: '/about-us',
    contactUs: '/contact-us',
    terms: '/terms',
    download: '/download',
    panel: {
        index: `/panel`,
        mobileMenu: () => `${__PATH.panel.index}/mobile-menu`,
        addPost: {
            index: () => `${__PATH.panel.index}/add-post`,
            locations: (category: string = ':category') => ({
                key: category,
                path: `${__PATH.panel.addPost.index()}/${category}`,
            }),
            main: (category?: string, location: string = ':location') => ({
                key: location,
                path: `${__PATH.panel.addPost.locations(category).path}/${location}`,
            }),
            fields: (category?: string, location?: string) => ({
                key: 'fields',
                path: `${__PATH.panel.addPost.main(category, location).path}/fields`,
            }),
        },
        myAds: {
            index: () => `${__PATH.panel.index}/my-ads`,
            detail: (slug?: routeParam) => `${__PATH.panel.myAds.index()}/${slug ?? ':slug'}`,
            edit: (slug?: routeParam) => `${__PATH.panel.myAds.detail(slug)}/edit`,
            preview: (slug?: routeParam) => `${__PATH.panel.myAds.detail(slug)}/preview`,
        },
        tickets: {
            index: () => `${__PATH.panel.index}/tickets`,
            new: () => `${__PATH.panel.tickets.index()}/new`,
            faq: () => `${__PATH.panel.tickets.index()}/faq`,
        },
        chat: (e?: { chatID?: number }) => {
            let url = `${__PATH.panel.index}/chat`;
            if (e?.chatID) url = url + '?chat=' + e.chatID;
            return url;
        },
        views: () => `${__PATH.panel.index}/views`,
        bookmarks: () => `${__PATH.panel.index}/bookmarks`,
    },
};

export { __PATH as PATH };

/* const appendParams = (searchParams?: object) =>
    searchParams && Object.keys(searchParams).length
        ? '?' + new URLSearchParams(filterObj(searchParams)).toString()
        : '';

const filterObj = (obj: any) => {
    Object.keys(obj).map((propName) => {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    });
    return obj;
}; */
